<div class="container-fluid pb-1 mx-auto" style="background-color: #567ba0;">
    <div class="mx-auto" style="width: 90%;">
        <p class="mb-0">
          <a class="btn btn-xs text-light shadow-none align-middle px-0" (click)="closeModal()">
            <img src="./assets/images/arrow-left.svg" width="18px">
            Volver</a>
        </p>
        <h2 class="text-light mb-0">Nueva tarea</h2>
    </div>
  </div>
  <form [formGroup]="requestForm">
        <div class="row my-3 mx-auto" style="width: 90%;">
            <div class="col">
                <div class="row mx-0 mb-3" style="justify-content: space-between;">
                    <div class="col-12">
                        <div class="row mb-2 position-relative">
                            <mdb-form-control class="custom-shadow">
                                <mdb-select mdbValidate placeholder="Linea" [filter]="true" (valueChange)="buildProductionEquipment($event)" formControlName="productionLineSelected">
                                    <mdb-option [value]="" disabled>Seleccione Linea</mdb-option>
                                    <mdb-option *ngFor="let item of productionLine" [value]="item.ID">
                                        {{ item.NAME }}
                                    </mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Linea</label>
                            </mdb-form-control>
                            <!-- <div *ngIf="requestForm?.get('productionLineSelected')?.touched && requestForm?.get('productionLineSelected')?.errors?.['required']" class="floating-alert">
                                <span class="error-icon me-2">⚠️</span>Seleccione una Linea
                            </div> -->
                        </div>
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <mdb-select placeholder="Equipo" [filter]="true" formControlName="productionEquipmentSelected">
                                    <mdb-option [value]="" disabled>Seleccione Equipo</mdb-option>
                                    <mdb-option *ngFor="let item of productionEquipment" [value]="item.ID">
                                        {{ item.NAME }}
                                    </mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Equipo</label>
                            </mdb-form-control>
                            <!-- <div *ngIf="requestForm?.get('productionEquipmentSelected')?.touched && requestForm?.get('productionEquipmentSelected')?.errors?.['required']" class="floating-alert">
                                <span class="error-icon me-2">⚠️</span>Seleccione un Equipo
                            </div> -->
                        </div>
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <mdb-select placeholder="Especialidad" [filter]="true" formControlName="productionSpecialitySelected">
                                    <mdb-option [value]="" disabled>Seleccione Especialidad</mdb-option>
                                    <mdb-option *ngFor="let item of productionSpeciality" [value]="item.ID">
                                        {{ item.NAME }}
                                    </mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Especialidad</label>
                            </mdb-form-control>
                            <!-- <div *ngIf="requestForm?.get('productionSpecialitySelected')?.touched && requestForm?.get('productionSpecialitySelected')?.errors?.['required']" class="floating-alert">
                                <span class="error-icon me-2">⚠️</span>Seleccione una Especialidad
                            </div> -->
                        </div>
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <mdb-select placeholder="Tipo" [filter]="true" formControlName="type">
                                    <mdb-option [value]="" disabled>Seleccione Tipo</mdb-option>
                                    <mdb-option *ngFor="let item of types" [value]="item.name">
                                        {{ item.name }}
                                    </mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Tipo</label>
                            </mdb-form-control>
                            <!-- <div *ngIf="requestForm?.get('productionSpecialitySelected')?.touched && requestForm?.get('productionSpecialitySelected')?.errors?.['required']" class="floating-alert">
                                <span class="error-icon me-2">⚠️</span>Seleccione una Especialidad
                            </div> -->
                        </div>
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow p-0">
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="component_stock_verification" formControlName="component_stock_verification">
                                    <label class="form-check-label" for="component_stock_verification">Verificación de stock componentes</label>
                                </div>
                            </mdb-form-control>
                            <mdb-form-control class="custom-shadow p-0">
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="is_necesary_stop_line" formControlName="is_necesary_stop_line">
                                    <label class="form-check-label" for="is_necesary_stop_line">¿Es necesario detener la línea?</label>
                                </div>
                            </mdb-form-control>
                        </div>
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <input mdbValidate mdbInput type="date" formControlName="schedule_date" class="form-control">
                                <label mdbLabel class="form-label active">Fecha programada</label>
                            </mdb-form-control>
                        </div>
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <mdb-select [multiple]="true" formControlName="collabs">
                                  <mdb-option *ngFor="let collaborator of collaborators" [value]="collaborator.ID_USER">{{collaborator.USER_NAME}}</mdb-option>
                                </mdb-select>
                                <label mdbLabel class="form-label">Seleccione colaboradores</label>
                              </mdb-form-control>
                        </div>
                        <div class="row mb-2 position-relative">
                            <mdb-form-control class="custom-shadow">
                                <textarea mdbValidate mdbInput placeholder="Comentarios para bodega" formControlName="comments_to_warehouse" rows="5" class="form-control"></textarea>
                                <label mdbLabel class="form-label">Comentarios para bodega</label>
                            </mdb-form-control>
                            <!-- <div *ngIf="requestForm?.get('problem')?.touched && requestForm?.get('problem')?.errors?.['required']" class="floating-alert">
                                <span class="error-icon me-2">⚠️</span>Ingrese un problema
                            </div> -->
                        </div>
                        <div>
                            <div class="row pt-1" style="justify-content: space-between;">
                                <div class="col-6 px-0">
                                    <button type="button" class="shadow-0 btn btn-md btn-success" (click)="newRegister()">
                                        Crear
                                    </button>
                                </div>
                                <div class="col-6 px-0 text-end">
                                    <button type="button" class="shadow-0 btn btn-md btn-danger" (click)="closeModal()">
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4"></div>
                </div>
            </div>
        </div>
  </form>

  <mdb-loading [show]="loadingFull" [fullscreen]="true">
      <div class="loading-spinner">
          <div class="spinner-border loading-icon" role="status"></div>
          <span class="loading-text">Cargando datos...</span>
      </div>
  </mdb-loading>